import { Box, Text, Flex } from '@chakra-ui/react';

export default function CountrySelection({
  selectedCountry,
  handleCountrySelect,
}) {
  return (
    <Box>
      <Flex direction="column" gap={4}>
        <CountryOption
          platform="España"
          icon={<Box>🇪🇸</Box>}
          isSelected={selectedCountry === 'spain'}
          onSelect={() => handleCountrySelect('spain')}
        />
        <CountryOption
          platform="México"
          icon={<Box>🇲🇽</Box>}
          isSelected={selectedCountry === 'mexico'}
          onSelect={() => handleCountrySelect('mexico')}
        />
      </Flex>
    </Box>
  );
}

function CountryOption({ platform, icon, isSelected, onSelect }) {
  return (
    <Flex
      alignItems="center"
      p={4}
      borderWidth={2}
      borderColor={isSelected ? 'black' : '#e2e8f0'}
      borderRadius="md"
      cursor="pointer"
      onClick={onSelect}
      _hover={{ borderColor: 'black' }}
    >
      <Box mr={4}>{icon}</Box>
      <Text fontSize="lg" fontWeight="medium">
        {platform}
      </Text>
    </Flex>
  );
}
